import { FIREBASE_STORAGE_URL } from "../../app-settings";
import { ClassNameProps } from "../../models/Props";
import { classNames } from "../../style/common";

export type CardBackProps = ClassNameProps;

export function CardBack(props: CardBackProps) {
    return (
        <img
            className={classNames("relative", props.className)}
            style={{ aspectRatio: "143/200" }}
            src={`${FIREBASE_STORAGE_URL}/images/cards/card-back.jpg`} />
    )
}